"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CRUDServiceNS = void 0;
var CRUDServiceNS;
(function (CRUDServiceNS) {
    let EventEmitterLabels;
    (function (EventEmitterLabels) {
        EventEmitterLabels["SAVE"] = "-save-event";
        EventEmitterLabels["UPDATE"] = "-update-event";
    })(EventEmitterLabels = CRUDServiceNS.EventEmitterLabels || (CRUDServiceNS.EventEmitterLabels = {}));
})(CRUDServiceNS = exports.CRUDServiceNS || (exports.CRUDServiceNS = {}));
//# sourceMappingURL=crud.types.js.map